// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalHeader__root--Nekj {
    position: relative;
    height: var(--mobile-modal-height);
    border-bottom: 1px solid var(--dark-tertiary-new-color);
    padding: 24px;
    display: flex;
    align-items: center;
}

    @media screen and (min-width: 1024px) {.ModalHeader__root--Nekj {
        height: 88px;
        padding: 24px
}
    }

.ModalHeader__title--H3NQ {
    color: var(--tertiary-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/ModalHeader/ModalHeader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,uDAAuD;IACvD,aAAa;IACb,aAAa;IACb,mBAAmB;AAMvB;;IAJI,uCARJ;QASQ,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,4BAA4B;AAChC","sourcesContent":[".root {\n    position: relative;\n    height: var(--mobile-modal-height);\n    border-bottom: 1px solid var(--dark-tertiary-new-color);\n    padding: 24px;\n    display: flex;\n    align-items: center;\n\n    @media (--large) {\n        height: 88px;\n        padding: 24px;\n    }\n}\n\n.title {\n    color: var(--tertiary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ModalHeader__root--Nekj`,
	"title": `ModalHeader__title--H3NQ`
};
export default ___CSS_LOADER_EXPORT___;
